class ProductUpsell extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-upsell-toggle]');
    this.content = this.querySelector('[data-upsell-content]');
    this.toggleRegion = this.querySelector('[data-upsell-toggle-region]');
    this.selectedVariantId = null;

    if (!this.toggle || !this.content) return;

    this.toggle.addEventListener('click', this.handleToggle.bind(this));

    if (this.toggleRegion) {
      this.toggleRegion.addEventListener('click', (event) => {
        if (this.toggle?.contains(event.target)) return;
        this.handleToggle();
      });

      this.toggleRegion.addEventListener('keydown', this.handleToggleRegionKeydown.bind(this));
    }

    // Listen for radio button changes
    const radioButtons = this.querySelectorAll('[data-upsell-option]');
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', this.handleOptionChange.bind(this));
    });

    // Initialize with checked option if any
    const checkedRadio = this.querySelector('[data-upsell-option]:checked');
    if (checkedRadio) {
      this.selectedVariantId = checkedRadio.dataset.upsellVariantId || checkedRadio.value;
    }
  }

  /**
   * Toggle the upsell content visibility
   */
  handleToggle() {
    const isChecked = this.toggle.getAttribute('aria-checked') === 'true';
    const newState = !isChecked;

    this.toggle.setAttribute('aria-checked', newState.toString());
    this.toggle.setAttribute(
      'aria-label',
      newState ? this.toggle.dataset.upsellToggleRemove : this.toggle.dataset.upsellToggleAdd,
    );
    this.toggleRegion?.setAttribute('aria-pressed', newState.toString());

    if (newState) {
      this.content.classList.remove('hidden');
      this.content.classList.add('flex');
    }
    else {
      this.content.classList.add('hidden');
      this.content.classList.remove('flex');
    }
    this.content.setAttribute('aria-hidden', (!newState).toString());
  }

  /**
   * Handle radio button option change
   * @param {Event} event
   */
  handleOptionChange(event) {
    const radio = event.target;
    this.selectedVariantId = radio.dataset.upsellVariantId || radio.value;

    // Update active label styling
    this.querySelectorAll('[data-upsell-label]').forEach((label) => {
      label.classList.replace('border-black', 'border-transparent');
    });
    radio.closest('[data-upsell-label]')?.classList.replace('border-transparent', 'border-black');
  }

  /**
   * Handle keyboard interaction for the toggle region
   * @param {KeyboardEvent} event
   */
  handleToggleRegionKeydown(event) {
    const isActivationKey = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';

    if (!isActivationKey) return;

    event.preventDefault();

    if (this.toggle?.contains(event.target)) return;

    this.handleToggle();
  }

  /**
   * Get the selected upsell variant ID
   * @returns {string|null} The variant ID if upsell is enabled and selected, null otherwise
   */
  getSelectedUpsellVariant() {
    const isEnabled = this.toggle?.getAttribute('aria-checked') === 'true';
    return isEnabled && this.selectedVariantId ? this.selectedVariantId : null;
  }
}

customElements.define('product-upsell', ProductUpsell);
